module.exports = __webpack_public_path__ + "assets/img/100@3x.4c4ee9cc.png";